import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    TranslateModule,
    NgbModule
  ]
})
export class InfoUserFormModule {
}
